import { getSportSubtitles } from '../utils/getSubtitles';

import { useCurrentSportStream } from './useCurrentSportStream';

export const useSubtitles = (contentId: string) => {
    const stream = useCurrentSportStream(contentId);

    return getSportSubtitles(stream);
};
